import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64bdc7e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "trust-data-accounting" }
const _hoisted_2 = { class: "section-heading" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Maintain trust data", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Accounting Software", -1))
const _hoisted_5 = { class: "search" }
const _hoisted_6 = { class: "search-inputs" }
const _hoisted_7 = { class: "search-bar" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-hm" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-search fa-lg" })
], -1))
const _hoisted_9 = { class: "checkbox-button ml-2" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "checkbox-elmt",
  style: {"border":"none"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "checkbox-text" }, "Show active only")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "space-filler",
  style: {"flex-grow":"1"}
}, null, -1))
const _hoisted_12 = { class: "accounting-software" }
const _hoisted_13 = { class: "ls-table" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = ["colspan"]
const _hoisted_16 = { key: 1 }
const _hoisted_17 = ["colspan"]
const _hoisted_18 = { key: 2 }
const _hoisted_19 = ["colspan"]
const _hoisted_20 = { "data-label": "Name" }
const _hoisted_21 = { "data-label": "Certified" }
const _hoisted_22 = { "data-label": "Status" }
const _hoisted_23 = { "data-label": "Show in ATCS" }
const _hoisted_24 = { "data-label": "Actions" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["onClick"]

export function render(_ctx, _cache) {
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ErrorIndicator = _resolveComponent("ErrorIndicator")
  const _component_AddEditAccountingSoftwareModal = _resolveComponent("AddEditAccountingSoftwareModal")
  const _component_AccountingSoftwareAuditTrailModal = _resolveComponent("AccountingSoftwareAuditTrailModal")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.searchKeyword) = $event)),
              placeholder: "Search accounting software"
            }, null, 512), [
              [_vModelText, _ctx.searchKeyword]
            ]),
            _hoisted_8
          ]),
          _createElementVNode("label", _hoisted_9, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.showActiveOnly) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.showActiveOnly]
            ]),
            _hoisted_10
          ]),
          _hoisted_11,
          _createElementVNode("button", {
            class: "btn btn-primary mr-2",
            onClick: _cache[2] || (_cache[2] = $event => (_ctx.addAccountingSoftware()))
          }, "Add new accounting software")
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("table", _hoisted_13, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeadings, (h, index) => {
              return (_openBlock(), _createElementBlock("th", null, [
                _createElementVNode("div", null, _toDisplayString(h.text), 1)
              ]))
            }), 256))
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_ctx.loadingContent)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                _createElementVNode("td", {
                  colspan: _ctx.tableHeadings.length
                }, [
                  _createVNode(_component_LoadingIndicator)
                ], 8, _hoisted_15)
              ]))
            : (_ctx.errorLoadingContent)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [
                  _createElementVNode("td", {
                    colspan: _ctx.tableHeadings.length
                  }, [
                    _createVNode(_component_ErrorIndicator)
                  ], 8, _hoisted_17)
                ]))
              : (!_ctx.loadingContent && !_ctx.errorLoadingContent && _ctx.filteredSoftwareList.length == 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [
                    _createElementVNode("td", {
                      colspan: _ctx.tableHeadings.length
                    }, "No Records", 8, _hoisted_19)
                  ]))
                : (!_ctx.loadingContent && !_ctx.errorLoadingContent && _ctx.filteredSoftwareList.length > 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.filteredSoftwareList, (a) => {
                      return (_openBlock(), _createElementBlock("tr", null, [
                        _createElementVNode("td", _hoisted_20, _toDisplayString(a.name), 1),
                        _createElementVNode("td", _hoisted_21, _toDisplayString(a.certifiedType?.name), 1),
                        _createElementVNode("td", _hoisted_22, _toDisplayString(a.status.name), 1),
                        _createElementVNode("td", _hoisted_23, _toDisplayString(a.isShowInAtcs ? 'Yes' : 'No'), 1),
                        _createElementVNode("td", _hoisted_24, [
                          _createElementVNode("button", {
                            class: "btn btn-default sml mr-2",
                            onClick: $event => (_ctx.editAccountingSoftware(a))
                          }, "Edit", 8, _hoisted_25),
                          _createElementVNode("button", {
                            class: "btn btn-default sml",
                            onClick: $event => (_ctx.viewAccountingSoftwareAuditTrail(a))
                          }, "Audit Trail", 8, _hoisted_26)
                        ])
                      ]))
                    }), 256))
                  : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("button", {
        class: "btn btn-primary sml mt-2",
        onClick: _cache[3] || (_cache[3] = $event => (_ctx.addAccountingSoftware()))
      }, "Add new accounting software")
    ]),
    (_ctx.showAddEditModal)
      ? (_openBlock(), _createBlock(_component_AddEditAccountingSoftwareModal, {
          key: 0,
          accountingApp: _ctx.selectedAccountSoftware,
          onCloseAddEditAccountingSoftwareModal: _cache[4] || (_cache[4] = $event => {_ctx.showAddEditModal = false;})
        }, null, 8, ["accountingApp"]))
      : _createCommentVNode("", true),
    (_ctx.showAuditTrailModal)
      ? (_openBlock(), _createBlock(_component_AccountingSoftwareAuditTrailModal, {
          key: 1,
          accountingApp: _ctx.selectedAccountSoftware,
          onCloseAuditTrailModal: _cache[5] || (_cache[5] = $event => {_ctx.showAuditTrailModal = false;})
        }, null, 8, ["accountingApp"]))
      : _createCommentVNode("", true)
  ]))
}